export default {
  loading: false,
  totalCount: 0,
};
